<p-galleria
  #gallery
  [value]="galleryItems"
  (mouseenter)="mouseEnterEvent()"
  (mouseleave)="mouseLeaveEvent()"
  [(activeIndex)]="activeIndex"
  [numVisible]="5"
  [showThumbnails]="showThumbnails"
  [showItemNavigators]="true"
  [showItemNavigatorsOnHover]="true"
  [circular]="true"
  (dragover)="dragoverEvent($event)">
  <ng-template pTemplate="item" let-item>
    <img [src]="getPropertyPictureUrl(item) | secureImage" />
  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <img [src]="getPropertyPictureUrl(item) | secureImage"/>
  </ng-template>
</p-galleria>
